export default __webpack_public_path__ + "static/media/no-image.ee103990.svg";